import type { CityConfig } from "../city-template/types";

export const reynoldsburgConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Ohio Department of Health", href: "https://odh.ohio.gov/know-our-programs/vital-statistics", description: "Official Ohio vital records office in Columbus" },
    { label: "Marriage Licenses — Franklin County Probate Court", href: "https://www.franklincountyohio.gov/probate", description: "Franklin County Probate Judge — marriage license issuance" },
    { label: "Divorce Records — Franklin County Clerk of Courts", href: "https://www.fccourtclerk.com/", description: "Franklin County Clerk of Courts — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Ohio Department of Health for online vital record orders" },
  ],
  city: "Reynoldsburg",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "reynoldsburg",
  route: "/reynoldsburg",
  title: "Emergency Passport Reynoldsburg, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Reynoldsburg, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Franklin and Licking Counties. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Reynoldsburg, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Reynoldsburg and Franklin County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Reynoldsburg%20Ohio%20suburban%20town%20center%20at%20golden%20hour%20with%20modern%20civic%20buildings%20and%20tree-lined%20residential%20streets%2C%20well-maintained%20suburban%20neighborhoods%20with%20green%20parks%20and%20community%20spaces%2C%20warm%20sunset%20light%20on%20local%20shops%20and%20rolling%20hills%2C%20Columbus%20suburb%20atmosphere%20with%20autumn%20foliage%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20clear%20sky&width=1800&height=700&seq=reynoldsburg-oh-hero-001&orientation=landscape",
  heroImageAlt: "Reynoldsburg Ohio suburban town center with civic buildings at golden hour",
  geoPosition: "39.9548;-82.8121",
  geoPlacename: "Reynoldsburg, Ohio",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 355 miles from Reynoldsburg via I-70",
  },
  nearbyCitiesZips: [
    { name: "Reynoldsburg", zips: "43068" },
    { name: "Columbus", zips: "43201–43299" },
    { name: "Pickerington", zips: "43147" },
    { name: "Pataskala", zips: "43062" },
    { name: "Blacklick", zips: "43004" },
    { name: "Gahanna", zips: "43230" },
    { name: "New Albany", zips: "43054" },
    { name: "Canal Winchester", zips: "43110" },
    { name: "Groveport", zips: "43125" },
    { name: "Lancaster", zips: "43130" },
    { name: "Westerville", zips: "43081, 43082, 43086" },
    { name: "Dublin", zips: "43016, 43017" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Reynoldsburg departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-global-line", title: "Columbus Suburb Coverage", desc: "Serving Franklin and Licking Counties" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Columbus, OH", route: "/columbus-oh" },
    { name: "Fast passport renewal in Lancaster, OH", route: "/lancaster-oh" },
    { name: "Emergency passport help in Newark, OH", route: "/newark-oh" },
    { name: "Urgent passport services in Dublin, OH", route: "/dublin-oh" },
    { name: "Same-day passport help in Delaware, OH", route: "/delaware-oh" },
    { name: "Passport courier services in Westerville, OH", route: "/columbus-oh" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Reynoldsburg remotely via secure courier. We do not have a walk-in office in Reynoldsburg — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Franklin and Licking County travelers.",
  fpcOfficeDistance: "Serving all of Franklin and Licking Counties",
  fpcOfficeAddress: "1330 Carnegie Ave, Cleveland, OH 44115",
  serviceAreaIntro: "From Reynoldsburg to Columbus, Pickerington, and Pataskala — Fast Passport Center serves the entire Franklin and Licking County region. We regularly help travelers from Gahanna, New Albany, Canal Winchester, and Westerville get their passports fast.",
  nearbyCitiesIntro: "We serve all Reynoldsburg neighborhoods and the surrounding Franklin and Licking County region including Columbus, Pickerington, Pataskala, Blacklick, Gahanna, New Albany, Canal Winchester, Groveport, Lancaster, Westerville, and Dublin. If you are anywhere in the Columbus eastern suburbs, we have you covered.",
  howItWorksIntro: "Most Reynoldsburg travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Reynoldsburg travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Reynoldsburg and Franklin County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Reynoldsburg? Here are the most common ones we hear from Franklin County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Reynoldsburg international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Matthew H.",
      location: "Reynoldsburg, OH",
      rating: 5,
      text: "My passport expired just before a business trip to London. Fast Passport Center had my renewal ready in 4 days. They guided me through every step and made it completely stress-free.",
      service: "Passport Renewal",
    },
    {
      name: "Natalie S.",
      location: "Pickerington, OH",
      rating: 5,
      text: "I thought I'd have to drive to Chicago or wait weeks for an emergency passport. Fast Passport Center handled everything remotely — got mine in 36 hours. Saved me a huge hassle.",
      service: "Emergency Passport",
    },
    {
      name: "Andrew C.",
      location: "Gahanna, OH",
      rating: 5,
      text: "Family trip to Mexico and my daughter's passport was expired. They found us the nearest acceptance facility and had her passport in 5 days. Couldn't be happier with the service.",
      service: "Child Passport",
    },
    {
      name: "Rachel B.",
      location: "New Albany, OH",
      rating: 5,
      text: "Last-minute conference in Paris with only 6 days notice. Fast Passport Center delivered my passport in 3 business days. Professional team and excellent communication.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "reynoldsburg-1",
      name: "Reynoldsburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6700 E Main St",
      city: "Reynoldsburg",
      state: "OH",
      zip: "43068",
      phone: "(614) 866-4624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Reynoldsburg Town Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main facility serving Reynoldsburg and Franklin County east suburbs. Appointments recommended. Multiple windows available.",
      icon: "ri-mail-line",
    },
    {
      id: "reynoldsburg-2",
      name: "Columbus Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "850 Twin Rivers Dr",
      city: "Columbus",
      state: "OH",
      zip: "43215",
      phone: "(614) 469-4624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Columbus, west of Reynoldsburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Columbus and western Franklin County residents. Less crowded than Reynoldsburg. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "reynoldsburg-3",
      name: "Pickerington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "80 W Columbus St",
      city: "Pickerington",
      state: "OH",
      zip: "43147",
      phone: "(614) 833-4624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Pickerington, east of Reynoldsburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Excellent option for eastern Franklin County residents. Easier parking than downtown Columbus.",
      icon: "ri-mail-line",
    },
    {
      id: "reynoldsburg-4",
      name: "Gahanna Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "395 Agler Rd",
      city: "Gahanna",
      state: "OH",
      zip: "43230",
      phone: "(614) 471-4624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Gahanna, north of Reynoldsburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Gahanna, New Albany, and northern Franklin County residents. Ample parking. Call for appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "reynoldsburg-5",
      name: "Franklin County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "373 S High St",
      city: "Columbus",
      state: "OH",
      zip: "43215",
      phone: "(614) 525-3600",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Franklin County Courthouse",
      website: "https://clerk.franklincountyohio.gov/",
      websiteLabel: "Franklin County Courts",
      notes: "Accepts passport applications. Good alternative to post office with extended hours and appointment availability.",
      icon: "ri-government-line",
    },
    {
      id: "reynoldsburg-6",
      name: "Westerville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "617 County Line Rd",
      city: "Westerville",
      state: "OH",
      zip: "43081",
      phone: "(614) 882-4624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Westerville, north of Reynoldsburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Franklin County and Delaware County. Appointments required.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Reynoldsburg photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Franklin County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Reynoldsburg applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Franklin County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Reynoldsburg travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Reynoldsburg." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Reynoldsburg address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Reynoldsburg before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Reynoldsburg for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Reynoldsburg?", a: "Fast Passport Center offers fast passport renewal in Reynoldsburg in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "Can I get a same-day passport appointment near Reynoldsburg?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 355 miles from Reynoldsburg — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Franklin County residents." },
    { q: "Can I expedite a child passport in Reynoldsburg?", a: "Yes. Fast Passport Center expedites child passports in Reynoldsburg for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Franklin County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Reynoldsburg with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "What is the closest passport agency to Reynoldsburg?", a: "The nearest regional passport agency to Reynoldsburg is the Chicago Passport Agency, approximately 355 miles away via I-70. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Reynoldsburg without any in-person agency visit required." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "How do I find a passport acceptance facility near Reynoldsburg?", a: "Franklin County has several passport acceptance facilities including the Reynoldsburg Post Office, Columbus Main Post Office, Pickerington Post Office, Gahanna Post Office, Westerville Post Office, and the Franklin County Clerk of Courts. We can help you locate the most convenient facility and schedule your appointment." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Reynoldsburg", address: "6350 E Main St, Reynoldsburg, OH 43068", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Reynoldsburg", address: "6950 E Broad St, Reynoldsburg, OH 43068", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Reynoldsburg", address: "2700 Brice Rd, Reynoldsburg, OH 43068", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Reynoldsburg", address: "6450 E Main St, Reynoldsburg, OH 43068", hours: "Mon–Sun: 8AM–10PM" },
    { name: "CVS Pharmacy — Columbus", address: "850 Twin Rivers Dr, Columbus, OH 43215", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Pickerington", address: "80 W Columbus St, Pickerington, OH 43147", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Gahanna", address: "395 Agler Rd, Gahanna, OH 43230", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Westerville", address: "617 County Line Rd, Westerville, OH 43081", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "Franklin County BMV — Reynoldsburg",
      address: "6350 E Main St, Reynoldsburg, OH 43068",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "BMV License Agency — Columbus",
      address: "850 Twin Rivers Dr, Columbus, OH 43215",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Alternative for Columbus and western Franklin County residents. REAL ID available.",
      featured: false,
    },
    {
      name: "BMV License Agency — Gahanna",
      address: "395 Agler Rd, Gahanna, OH 43230",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Convenient for Gahanna, New Albany, and northern Franklin County residents.",
      featured: false,
    },
    {
      name: "AAA — Reynoldsburg",
      address: "6350 E Main St, Reynoldsburg, OH 43068",
      hours: "Mon–Fri: 8AM–5:30PM, Sat: 9AM–12PM",
      note: "AAA members can renew licenses and access passport photo services at this location.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CMH",
      name: "John Glenn Columbus International Airport",
      distance: "12 miles west of Reynoldsburg",
      address: "4600 International Gateway, Columbus, OH 43219",
      note: "Major international hub with flights to Europe, Canada, Mexico, and the Caribbean. Most convenient for Reynoldsburg travelers.",
      flightUrl: "https://www.flycmh.com/",
      flightLabel: "Columbus Airport",
      featured: true,
    },
    {
      code: "LCK",
      name: "Rickenbacker International Airport",
      distance: "18 miles south of Reynoldsburg",
      address: "2241 John Circle Dr, Columbus, OH 43217",
      note: "Cargo and limited passenger airport. Some charter and seasonal flights available.",
      flightUrl: "https://www.rickenbacker.org/",
      flightLabel: "Rickenbacker Airport",
      featured: false,
    },
    {
      code: "DAY",
      name: "Dayton International Airport",
      distance: "75 miles west of Reynoldsburg",
      address: "3600 Terminal Dr, Dayton, OH 45377",
      note: "Alternative regional airport with flights to major hubs. Consider for domestic travel.",
      flightUrl: "https://flydayton.com/",
      flightLabel: "Dayton Airport",
      featured: false,
    },
  ],
};